import { createRequestTypes } from '../../utils';

export const SAVE_BUTTON_CLICKED = 'allergenModal/SAVE_BUTTON_CLICKED';
export const SAVE_RAWMAT_PROPORTION_ALLERGENS = createRequestTypes('allergenModal/SAVE_RAWMAT_PROPORTION_ALLERGENS');
